export enum TripAnnotationActionTypes {
    SET_TRIPANNOTATIONS = "SET_TRIPANNOTATIONS",
    CLEAR_TRIPANNOTATIONS = "CLEAR_TRIPANNOTATIONS"
}